// extracted by mini-css-extract-plugin
export default {"base":"News_base__dcETF","head":"News_head__4b8Y5","body":"News_body__cEat4","inner":"News_inner__-j++g"};